module.exports = __webpack_public_path__ + "582c5ce179c731c6f9f13c66b873d83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/img/cover-background.jpg
// module id = FkW1
// module chunks = 5